import React, { useState, Fragment, useEffect, useRef } from 'react';
import {
	Paper, Grid, TextField, FormControlLabel, Tooltip,
	Typography, FormControl, RadioGroup, Radio,
	Select, MenuItem, InputLabel
} from '@material-ui/core';
import { useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import { masterData } from "./data";
import errormesages from './errormessages';
export default function EirPersonalInformation(props) {
	const classes = useStyle();
	const { errors, control } = useFormContext();
	const { validation } = errormesages;
	const dateInputRef = useRef();
	const monthInputRef = useRef();
	const yearInputRef = useRef();
	const nationalityInputRef = useRef();
	const addressProfInputRef = useRef();
	const residentialInputRef = useRef();
	const addressTimeInputRef = useRef();
	const idTypeInputRef = useRef();
	const idNumberInputRef = useRef();
	const genderInputRef = useRef();
	const occupationStatusInputRef = useRef();
	const occupationTypeInputRef = useRef();
	const timeEmployerInputRef = useRef();
	const [years, setYears] = useState([]);
	// const [showOccupationType, setShowOccupationType] = useState(false);
	// const [showTimeEmployer, setTimeEmployer] = useState(false);
	useEffect(() => {
		noOfYears();
	}, []);
	// const hideShowOccupation = (type) => {
	// 	if (type === "Full Time" || type === "Part Time" || type === "Temporary") {
	// 		setShowOccupationType(true);
	// 		setTimeEmployer(true);
	// 	} else if (type === "Self Employed") {
	// 		setShowOccupationType(true);
	// 		setTimeEmployer(false);
	// 	} else {
	// 		setShowOccupationType(false);
	// 		setTimeEmployer(false);
	// 	}
	// };
	const noOfYears = () => {
		const years = [];
		var today = new Date();
		for (var i = 1911; i <= today.getFullYear() - 18; i++)
			years.push(i);
		years.sort(function (a, b) {
			return b - a;
		});
		setYears(years);
	};
	return (
		<Fragment>
			<Grid item sm={12} className={classes.personalPadding}>
				<Paper className={classes.contactPaper} variant='elevation' elevation={4}>
					<Grid container>
						<Grid item sm={6}>
							<Grid container>
								<Grid item sm={7}>
									<h2 className={classes.contactTxt}>
										Personal Information
									</h2>
								</Grid>
								<Grid item sm={5}>
									<Tooltip
										enterTouchDelay={20}
										leaveTouchDelay={15000}
										title="The following questions are used to assist eir in processing potential customer applications and in determining if a potential customer can apply for their chosen service by verifying the information provided. These checks protect both eir and the customer. They also protect from provisioning a service for which a customer is not eligible."
										placement='right'
									>
										<HelpOutlinedIcon
											style={{ color: '#892BA0', marginTop: '10px', marginLeft: '-1rem' }}
											className={classes.questionIconPersonal}
										/>
									</Tooltip>
								</Grid>
							</Grid>
						</Grid>
						<Grid container >
							<Grid item sm={6} xs={12} className={classes.paddingRightDOB}>
								<Grid>
									<Typography className={classes.personalLabel}> Date of Birth <span style={{ color: 'red', textAlign: 'center' }} >*</span></Typography>
								</Grid>
								<Grid container spacing={3} xs={13}>
									<Grid item >
										<FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
											<InputLabel required
												error={Boolean(errors.date)}
											>DD</InputLabel>
											<Controller
												control={control}
												name="date"
												id="date"
												inputRef={dateInputRef}
												defaultValue=""
												rules={{ required: { value: true, message: validation.dobRequired } }}
												error={Boolean(errors.date)}
												onFocus={() => {
													dateInputRef.current.focus();
												}}
												as={
													<Select
														id='date'
														label="Date"
													>
														{masterData.filter(masterData => masterData.id === 'dobDate').map((data) =>
															data.value.map((val) =>
															(
																<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
																	{val.label}
																</MenuItem>
															))
														)}
													</Select>
												}
											/>
										</FormControl>
									</Grid>
									<Grid item >
										<FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
											<InputLabel required
												error={Boolean(errors.month)}
											>MM</InputLabel>
											<Controller
												control={control}
												name="month"
												id="month"
												inputRef={monthInputRef}
												defaultValue=""
												rules={{ required: { value: true, message: validation.dobRequired } }}
												error={Boolean(errors.month)}
												onFocus={() => {
													monthInputRef.current.focus();
												}}
												as={
													<Select
														id="month"
														label="Month"
													>
														{masterData.filter(masterData => masterData.id === 'dobMonth').map((data) =>
															data.value.map((val) =>
															(
																<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
																	{val.label}
																</MenuItem>
															))
														)}
													</Select>
												}
											/>
										</FormControl>
									</Grid>

									<Grid item >
										<FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
											<InputLabel required
												error={Boolean(errors.year)}
											>YY</InputLabel>
											<Controller
												control={control}
												name="year"
												id="year"
												inputRef={yearInputRef}
												defaultValue=""
												rules={{ required: { value: true, message: validation.dobRequired } }}
												error={Boolean(errors.year)}
												onFocus={() => {
													yearInputRef.current.focus();
												}}
												as={
													<Select
														id="year"
														label="Year"
													>years
														{years.map((data) =>

															<MenuItem key={data} value={data} className={classes.selectLabel}>
																{data}
															</MenuItem>
														)}
													</Select>
												}
											/>
										</FormControl>
									</Grid>
								</Grid>
								<Grid sm={6}>
									{errors.date && errors.month && errors.year ?
										<ErrorMessage errors={errors} name='date'>
											{({ message }) => <p className={classes.errorMessage}>{message}</p>}
										</ErrorMessage>
										: errors.date ?
											<ErrorMessage errors={errors} name='date'>
												{({ message }) => <p className={classes.errorMessage}>{message}</p>}
											</ErrorMessage>
											: errors.month ?
												<ErrorMessage errors={errors} name='month'>
													{({ message }) => <p className={classes.errorMessage}>{message}</p>}
												</ErrorMessage>
												: errors.year ?
													<ErrorMessage errors={errors} name='year'>
														{({ message }) => <p className={classes.errorMessage}>{message}</p>}
													</ErrorMessage>
													: ''
									}
								</Grid>
								<Grid>
									<p className={classes.mobileInfoTip}>You need to be 18 years or older.</p>
								</Grid>
							</Grid>
							{/* <Grid item sm={4} className={classes.paddingLeftItem}>
                        <Grid>
                        <Typography className={classes.personalLabel}> Gender <span style={{ color: 'red', textAlign: 'center' }} >*</span></Typography>
                        </Grid>
                        <FormControl color="secondary" variant="outlined" fullWidth size="small"  className={classes.dropDownMinWidth}>
						<Controller
								control={control}
								name="gender"
								id="gender"
								inputRef={genderInputRef}
								defaultValue=""
								rules={{ required: { value: true, message: validation.genderRequired } }}
								error={Boolean(errors.gender)}
								as={
									<RadioGroup aria-label="gender" name="gender" id='gender'
									className={classes.radioButtom}>
									<Grid container>
									<Grid item>
									<FormControlLabel value="male" control={<Radio />} label="Male" className={classes.personalLabel}/>
									</Grid>
									<Grid item>
									<FormControlLabel value="female" control={<Radio />} label="Female" className={classes.personalLabel}/>
									</Grid>
									</Grid>
								</RadioGroup>
								}
							/>
							<ErrorMessage errors={errors} name='gender'>
								{({ message }) => <p className={classes.errorMessageGender}>{message}</p>}
							</ErrorMessage>			
						</FormControl>  
                    </Grid> */}
						</Grid>
						<Grid container >
							{/* <Grid item sm={6} xs={12} className={classes.paddingRightItem}>
								<FormControl color="secondary" variant="outlined" fullWidth size="small">
									<InputLabel required
										error={Boolean(errors.nationality)}
									>Nationality</InputLabel>
									<Controller
										control={control}
										name="nationality"
										id="nationality"
										inputRef={nationalityInputRef}
										defaultValue=""
										rules={{ required: { value: true, message: validation.nationalityRequired } }}
										error={Boolean(errors.nationality)}
										as={
											<Select
												id='nationality'
												label="Nationality"
											>
												{masterData.filter(masterData => masterData.id === 'nationality').map((data) =>
													data.value.map((val) =>
													(
														<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
															{val.label}
														</MenuItem>
													))
												)}

											</Select>
										}
									/>
									<Grid className={classes.errorMessageHeight}>
										<ErrorMessage errors={errors} name='nationality'>
											{({ message }) => <p className={classes.errorMessage}>{message}</p>}
										</ErrorMessage>
									</Grid>
								</FormControl>
							</Grid> */}
						</Grid>
						{props.showPersonalInfo ?
							<Grid container >
								<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
									<FormControl color="secondary" variant="outlined" fullWidth size="small">
										<InputLabel required
											error={Boolean(errors.residential)}
										>Residential Status</InputLabel>
										<Controller
											control={control}
											name="residential"
											id="residential"
											inputRef={residentialInputRef}
											defaultValue=""
											rules={{ required: { value: true, message: validation.residentialRequired } }}
											error={Boolean(errors.residential)}
											onFocus={() => {
												residentialInputRef.current.focus();
											}}
											as={
												<Select
													id='residential'
													label="Residential Status"
												>
													{masterData.filter(masterData => masterData.id === 'residentialStatus').map((data) =>
														data.value.map((val) =>
														(
															<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
																{val.label}
															</MenuItem>
														))
													)}
												</Select>
											}
										/>
										<Grid className={classes.errorMessageHeight}>
											<ErrorMessage errors={errors} name='residential'>
												{({ message }) => <p className={classes.errorMessage}>{message}</p>}
											</ErrorMessage>
										</Grid>
									</FormControl>
								</Grid>
								{/* </Grid> */}
								{/* <Grid container > */}
								<Grid item sm={6} xs={12} className={classes.paddingLeftItem}>
									<FormControl color="secondary" variant="outlined" fullWidth size="small">
										<InputLabel required
											error={Boolean(errors.addressProof)}
										>Proof of Address</InputLabel>
										<Controller
											control={control}
											name="addressProof"
											id="addressProof"
											inputRef={addressProfInputRef}
											defaultValue=""
											rules={{ required: { value: true, message: validation.addressProofRequired } }}
											error={Boolean(errors.addressProof)}
											error={Boolean(errors.residential)}
											onFocus={() => {
												addressProfInputRef.current.focus();
											}}
											as={
												<Select
													id='addressProof'
													label="Proof of Address"
												>
													{masterData.filter(masterData => masterData.id === 'proofOfAddress').map((data) =>
														data.value.map((val) =>
														(
															<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
																{val.label}
															</MenuItem>
														))
													)}
												</Select>
											}
										/>
										<Grid className={classes.errorMessageHeight}>
											<ErrorMessage errors={errors} name='addressProof'>
												{({ message }) => <p className={classes.errorMessage}>{message}</p>}
											</ErrorMessage>
										</Grid>
									</FormControl>
								</Grid>
							</Grid>
							: ''}
						{/* </Grid> */}

						{/* <Grid item sm={6} xs={12} className={classes.paddingLeftItem}>
								<FormControl color="secondary" variant="outlined" fullWidth size="small">
									<InputLabel required
										error={Boolean(errors.timeAddress)}
									>Time At Address</InputLabel>
									<Controller
										control={control}
										name="timeAddress"
										id="timeAddress"
										inputRef={addressTimeInputRef}
										defaultValue=""
										rules={{ required: { value: true, message: validation.addressTileRequired } }}
										error={Boolean(errors.timeAddress)}
										as={
											<Select
												id='timeAddress'
												label="Time At Address"
											>
												{masterData.filter(masterData => masterData.id === 'timeAtAddress').map((data) =>
													data.value.map((val) =>
													(
														<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
															{val.label}
														</MenuItem>
													))
												)}
											</Select>
										}
									/>
									<Grid className={classes.errorMessageHeight}>
										<ErrorMessage errors={errors} name='timeAddress'>
											{({ message }) => <p className={classes.errorMessage}>{message}</p>}
										</ErrorMessage>
									</Grid>
								</FormControl>
							</Grid> */}
						{/* </Grid> */}

						{props.showProof ? (props.showPersonalInfo ?
							<Grid container >
								<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
									<FormControl color="secondary" variant="outlined" fullWidth size="small">
										<InputLabel required
											error={Boolean(errors.idType)}
										>ID Type</InputLabel>
										<Controller
											control={control}
											name="idType"
											id="idType"
											inputRef={idTypeInputRef}
											defaultValue=""
											rules={{ required: { value: true, message: validation.idRequired } }}
											error={Boolean(errors.idType)}
											onFocus={() => {
												idTypeInputRef.current.focus();
											}}
											as={
												<Select
													id='idType'
													label="ID Type"
												>
													{masterData.filter(masterData => masterData.id === 'idType').map((data) =>
														data.value.map((val) =>
														(
															<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
																{val.label}
															</MenuItem>
														))
													)}
												</Select>
											}
										/>
										<Grid className={classes.errorMessageHeight}>
											<ErrorMessage errors={errors} name='idType'>
												{({ message }) => <p className={classes.errorMessage}>{message}</p>}
											</ErrorMessage>
										</Grid>
									</FormControl>
								</Grid>
								<Grid item sm={6} xs={12} className={classes.paddingLeftItem}>
									<Controller
										as={<TextField inputRef={idNumberInputRef} color="secondary" />}
										control={control}
										fullWidth
										id="idNumber"
										name="idNumber"
										label="ID Number"
										variant="outlined"
										size="small"
										error={Boolean(errors.idNumber)}
										onFocus={() => {
											idNumberInputRef.current.focus();
										}}
										required
										rules={{
											required: { value: true, message: validation.idNumberRequired },
										}}
									/>
									<Grid className={classes.errorMessageHeight}>
										<ErrorMessage errors={errors} name="idNumber">
											{({ message }) => <p className={classes.errorMessage}>{message}</p>}
										</ErrorMessage>
									</Grid>
								</Grid>
							</Grid>
							: '')
							: ''}

						<Grid container>
							{/* <Grid item sm={6} xs={12} className={classes.paddingRightItem}>
								<FormControl color="secondary" variant="outlined" fullWidth size="small">
									<InputLabel required
										error={Boolean(errors.occupationStatus)}>Occupation Status</InputLabel>
									<Controller
										control={control}
										name="occupationStatus"
										id="occupationStatus"
										inputRef={occupationStatusInputRef}
										defaultValue=""
										error={Boolean(errors.occupationStatus)}
										rules={{ required: { value: true, message: validation.occupationStatusRequired } }}
										as={
											<Select
												id='occupationStatus'
												label="Occupation Status"
											>
												{masterData.filter(masterData => masterData.id === 'occupationStatus').map((data) =>
													data.value.map((val) =>
													(
														<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
															{val.label}
														</MenuItem>
													))
												)}
											</Select>
										}
										onChange={([event]) => {
											hideShowOccupation(event.target.value);
											return event.target.value;
										}}
									/>
									<Grid className={classes.errorMessageHeight}>
										<ErrorMessage errors={errors} name='occupationStatus'>
											{({ message }) => <p className={classes.errorMessage}>{message}</p>}
										</ErrorMessage>
									</Grid>
								</FormControl>
							</Grid> */}
							{/* {showOccupationType ? */}
							{props.showPersonalInfo ?
								<Grid item sm={6} xs={12} className={classes.paddingRightItem}>
									<FormControl color="secondary" variant="outlined" fullWidth size="small">
										<InputLabel required
											error={Boolean(errors.occupationType)}
										>Occupation Type</InputLabel>
										<Controller
											control={control}
											name="occupationType"
											id="occupationType"
											inputRef={occupationTypeInputRef}
											defaultValue=""
											rules={{ required: { value: true, message: validation.occupationTypeRequired } }}
											error={Boolean(errors.occupationType)}
											onFocus={() => {
												occupationTypeInputRef.current.focus();
											}}
											as={
												<Select
													id='occupationType'
													label="Occupation Type"
												>
													{masterData.filter(masterData => masterData.id === 'occupationType').map((data) =>
														data.value.map((val) =>
														(
															<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
																{val.label}
															</MenuItem>
														))
													)}
												</Select>
											}
										/>
										<Grid className={classes.errorMessageHeight}>
											<ErrorMessage errors={errors} name='occupationType'>
												{({ message }) => <p className={classes.errorMessage}>{message}</p>}
											</ErrorMessage>
										</Grid>
									</FormControl>
								</Grid>
								: ''}
							{/* : ''} */}
						</Grid>
						{/* {showTimeEmployer ? */}
						<Grid container >
							{/* <Grid item sm={6} xs={12} className={classes.paddingRightItem}>
								<FormControl color="secondary" variant="outlined" fullWidth size="small">
									<InputLabel required
										error={Boolean(errors.timeEmployer)}
									>Time with Employer</InputLabel>
									<Controller
										control={control}
										name="timeEmployer"
										id="timeEmployer"
										inputRef={timeEmployerInputRef}
										defaultValue=""
										rules={{ required: { value: true, message: validation.employerTimeRequired } }}
										error={Boolean(errors.timeEmployer)}
										as={
											<Select
												id='timeEmployer'
												label="Time with Employer"
											>
												{masterData.filter(masterData => masterData.id === 'timeEmployer').map((data) =>
													data.value.map((val) =>
													(
														<MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
															{val.label}
														</MenuItem>
													))
												)}
											</Select>
										}
									/>
									<Grid className={classes.errorMessageHeight}>
										<ErrorMessage errors={errors} name='timeEmployer'>
											{({ message }) => <p className={classes.errorMessage}>{message}</p>}
										</ErrorMessage>
									</Grid>
								</FormControl>
							</Grid> */}
						</Grid>
						{/* : ''} */}
					</Grid>
				</Paper>
			</Grid>
		</Fragment>
	);
}